/**
 * Politica Geral de Uso Responsavel da Empiria, versao de 23 de julho de 2026.
 * Transcricao integral do PDF aprovado -- nao reescrever nem resumir. Cada
 * bloco corresponde a um item do documento; o `id` e a numeracao original,
 * que os outros documentos citam ("item 3.4", "item L").
 */
const usoResponsavel = [
    {
        tipo: "secao",
        texto:
            "VISÃO GERAL",
    },
    {
        tipo: "item",
        id: "A.",
        texto:
            "Esta Política tem por objetivo fixar diretrizes sobre o uso responsável da Plataforma, incluindo exemplos de formatos ou conteúdos que não podem ser cadastrados, divulgados ou comercializados mediante a Plataforma.",
    },
    {
        tipo: "item",
        id: "B.",
        texto:
            "Esta Política representa um conjunto de escolhas da Empiria destinadas a proporcionar uma plataforma especialmente planejada para que todos possam realizar sonhos e ou mudar as suas vidas através da troca de experiência por meio dos Encontros. A Empiria dedica muito tempo refletindo sobre os conteúdos que podem ser divulgados na Plataforma, avaliando tendências à medida que certos assuntos evoluem. Por isso, esta Política é um documento vivo, que pode ser atualizado a qualquer tempo.",
    },
    {
        tipo: "item",
        id: "C.",
        texto:
            "A lista de exemplos relacionados abaixo não é exaustiva. Ela serve para orientar nossos times de verificação no momento de avaliar a ocorrência de possíveis violações a esta Política, bem como para esclarecer à comunidade de Usuários alguns dos principais formatos ou conteúdos que não devem compor a Plataforma.",
    },
    {
        tipo: "item",
        id: "D.",
        texto:
            "A Empiria pode buscar o auxílio de colaboradores externos nos seus processos de tomada de decisão a respeito das ocorrências relativas a possíveis violações desta Política. A decisão final sobre a aceitação do cadastro, a remoção ou manutenção de um Serviço na Plataforma, ou a adoção de qualquer outra medida, será sempre da Empiria, a quem compete avaliar as ocorrências mediante a aplicação dos Termos e desta Política.",
    },
    {
        tipo: "item",
        id: "E.",
        texto:
            "Nós temos muito orgulho de sermos hoje uma das ferramentas mais poderosas de realização de videoconferências. Quando tomamos decisões, sabemos que nem todas as pessoas concordarão com nossas conclusões, mas sempre buscamos contemplar os diferentes pontos de vista relativos às ocorrências que surgem, para criar um ambiente seguro para a nossa comunidade. A aplicação desta Política pode depender de informações disponíveis em diferentes momentos, e buscamos aplicá-la sempre considerando o contexto e as nuances em que certas palavras, ideias, imagens ou sons se manifestam no conteúdo dos Produtos cadastrados na Plataforma.",
    },
    {
        tipo: "secao",
        texto:
            "1. PRODUTOS QUE VIOLEM A LEGISLAÇÃO APLICÁVEL",
    },
    {
        tipo: "item",
        id: "1.1.",
        texto:
            "Você não pode usar a Plataforma para criar, divulgar ou comercializar qualquer serviço ou conteúdo que viole ou possa violar a legislação aplicável em vigor. São exemplos desses, sem prejuízo de outros:",
    },
    {
        tipo: "item",
        id: "1.1.1.",
        texto:
            "Encontros e/ou Conteúdos cuja comercialização ou divulgação seja expressamente proibida por lei.",
    },
    {
        tipo: "item",
        id: "1.1.2.",
        texto:
            "Encontros e/ou Conteúdos que violem a intimidade, a honra, a privacidade, a imagem, o nome ou qualquer outro direito da personalidade de terceiros.",
    },
    {
        tipo: "item",
        id: "1.1.3.",
        texto:
            "Encontros e/ou Conteúdos que violem a proteção de dados pessoais ou direitos de terceiros sobre seus dados pessoais, como listas de endereços ou bancos de dados pessoais desprovidos de base legal válida.",
    },
    {
        tipo: "item",
        id: "1.1.4.",
        texto:
            "Encontros e/ou Conteúdos que violem direitos de propriedade intelectual de terceiros. Assim, por exemplo, você não pode criar, divulgar ou comercializar na Plataforma qualquer Produto com conteúdo que viole direitos autorais de terceiros, como direitos sobre músicas, textos, imagens, vídeos ou software. Também não pode criar, divulgar ou comercializar na Plataforma Produtos que contenham programas acadêmicos ou programas desenvolvidos para alguma entidade educacional. Você não pode criar, divulgar ou comercializar na Plataforma qualquer Produto que viole marcas, patentes, modelos, desenhos industriais ou segredos industriais. Ainda, você não pode criar, divulgar ou comercializar na Plataforma qualquer Produto que contenha software para OEM, NFR, cópias ou arquivos de backup.",
    },
    {
        tipo: "item",
        id: "1.1.5.",
        texto:
            "Encontros com conteúdo ministrado por quem não preenche as condições exigidas por lei para exercer a profissão ou a atividade econômica com que o Produto se relaciona.",
    },
    {
        tipo: "item",
        id: "1.1.6.",
        texto:
            "Encontros e Conteúdos que divulguem, sem comprovação, serem autorizados ou reconhecidos por órgãos designados por lei para tanto.",
    },
    {
        tipo: "secao",
        texto:
            "2. PRODUTOS QUE INCENTIVEM A PRÁTICA DE VIOLÊNCIA, DE DISCRIMINAÇÃO, DE CRIMES OU DE ATIVIDADES PROIBIDAS",
    },
    {
        tipo: "item",
        id: "2.1.",
        texto:
            "Você não pode usar a Plataforma",
    },
    {
        tipo: "item",
        id: "2.2.",
        texto:
            "para criar, divulgar ou comercializar qualquer Encontro e/ou Conteúdo que, direta ou indiretamente, implique ou possa implicar, incite ou possa incitar a prática de violência, de discriminação, de atividades proibidas ou de crimes. São exemplos desses Produtos, sem prejuízo de outros:",
    },
    {
        tipo: "item",
        id: "2.2.1.",
        texto:
            "Encontros cujo conteúdo promova a violência, a ameaça, a intolerância ou a intimidação contra uma pessoa ou um grupo de pessoas.",
    },
    {
        tipo: "item",
        id: "2.2.2.",
        texto:
            "Encontros cujo conteúdo apresente ataque direto a uma pessoa ou grupo de pessoas com base em características como raça, gênero, orientação sexual, identidade de gênero, religião, naturalidade, condição mental, condição médica ou condição física.",
    },
    {
        tipo: "item",
        id: "2.2.3.",
        texto:
            "Encontros cujo conteúdo promova discurso com a intenção de desumanizar, degradar, intimidar ou reforçar estereótipos negativos ou prejudiciais com base em características como raça, gênero, orientação sexual, identidade de gênero, religião, naturalidade, condição mental, condição médica ou condição física. Você também não pode criar, divulgar ou comercializar na Plataforma qualquer Produto cujo conteúdo direcione a alguém declarações ou tratamentos com essas mesmas intenções.",
    },
    {
        tipo: "item",
        id: "2.2.4.",
        texto:
            "Encontros cujo conteúdo, no todo ou em parte, seja capaz de configurar a prática de crime ou contravenção.",
    },
    {
        tipo: "item",
        id: "2.2.5.",
        texto:
            "Encontros cujas características indiquem ou se relacionem a potencial prática de fraude, de lavagem de dinheiro, de financiamento do terrorismo ou de atividades ilegais.",
    },
    {
        tipo: "item",
        id: "2.2.6.",
        texto:
            "Encontros que façam alusão ou promovam o uso ilegal de armas de fogo, narcóticos, tóxicos ou qualquer tipo de drogas ilegais, bem como de qualquer substância ilícita ou cujo consumo dependa por lei de prescrição médica ou autorização de qualquer órgão competente.",
    },
    {
        tipo: "item",
        id: "2.2.7.",
        texto:
            "Encontros que prometam sucesso em loterias ou jogos de azar, bem como em qualquer atividade ou prática que dependa de fatores relacionados preponderantemente à sorte para seu sucesso.",
    },
    {
        tipo: "item",
        id: "2.2.8.",
        texto:
            "Encontros que promovam o assédio sexual, a pedofilia, a prostituição ou qualquer outro tipo de exploração sexual, como a prática ou incitação à pornografia de vingança.",
    },
    {
        tipo: "secao",
        texto:
            "3. PRODUTOS RELACIONADOS A ATIVIDADES FRAUDULENTAS OU ANTIÉTICAS",
    },
    {
        tipo: "item",
        id: "3.1.",
        texto:
            "Você não pode usar a Plataforma para criar, divulgar ou comercializar qualquer Encontro cujo conteúdo envolva atividades fraudulentas ou antiéticas. São exemplos desses Encontros e/ou Conteúdo, sem prejuízo de outros:",
    },
    {
        tipo: "item",
        id: "3.1.1.",
        texto:
            "Encontros e/ou Conteúdos que induzam, ensinem ou de qualquer forma incentivem outros Usuários a violar os Termos ou as Políticas da Empiria.",
    },
    {
        tipo: "item",
        id: "3.1.2.",
        texto:
            "Encontros e/ou Conteúdos cujo conteúdo incite, indique ou de qualquer maneira promova qualquer comportamento ilegal.",
    },
    {
        tipo: "item",
        id: "3.1.3.",
        texto:
            "Encontros e/ou Conteúdos que deixem de prestar informações necessárias e adequadas a seu respeito.",
    },
    {
        tipo: "item",
        id: "3.1.4.",
        texto:
            "Encontros cujo conteúdo seja intencionalmente enganoso, capaz de gerar danos a seus Usuários ou a terceiros.",
    },
    {
        tipo: "item",
        id: "3.1.5.",
        texto:
            "Encontros cujo conteúdo apresente informações sabidamente falsas como se fossem verdadeiras. Por exemplo, você não pode criar, divulgar ou comercializar na Plataforma qualquer Produto cujo conteúdo divulgue notícias, inclusive artigos de mídia, relatando fatos como se fossem verdadeiros, ou sugerindo que podem ser verdadeiros, se houver evidências inequívocas de que são falsos. A Empiria pode remover da Plataforma qualquer Encontro que ela verificar com conteúdo dessa natureza, qualquer que tenha sido a finalidade do emprego do conteúdo falso. A Empiria aplicará as medidas cabíveis com especial rigor se verificar que o uso de informações falsas tem por objetivo interferir ou influenciar indevidamente em uma eleição.",
    },
    {
        tipo: "item",
        id: "3.1.6.",
        texto:
            "Encontros e/ou Conteúdos que promovam esquemas de pirâmide ou similares, cujo funcionamento dependa prioritariamente do aporte de recursos financeiros por novos participantes para remunerar participantes anteriores.",
    },
    {
        tipo: "secao",
        texto:
            "4. PRODUTOS CUJOS FORMATOS OU CONTEÚDOS SEJAM INCOMPATÍVEIS COM O MODELO DE NEGÓCIO, OS VALORES OU PRINCÍPIOS DA EMPIRIA",
    },
    {
        tipo: "item",
        id: "4.1.",
        texto:
            "Você não pode usar a Plataforma para criar, divulgar ou comercializar qualquer Encontro cujos formatos ou conteúdos sejam incompatíveis com o modelo de negócio, os valores ou os princípios da Empiria. São exemplos desses Encontros e/ou Conteúdos sem prejuízo de outros:",
    },
    {
        tipo: "item",
        id: "4.1.1.",
        texto:
            "Produtos que resultem na comercialização de coisas corpóreas ou de valores mobiliários.",
    },
    {
        tipo: "item",
        id: "4.1.2.",
        texto:
            "Encontros cuja possibilidade de compra esteja condicionada à compra de outros Encontros ou Conteúdos.",
    },
    {
        tipo: "item",
        id: "4.1.3.",
        texto:
            "Encontros que tenham como principal estratégia de divulgação o próprio uso da Plataforma, podendo levar a audiência a crer que há algum tipo de custo ou requisito especial para realização de cadastro ou utilização dos Serviços da Empiria, além daqueles já previstos nos Termos da Empiria.",
    },
    {
        tipo: "item",
        id: "4.1.4.",
        texto:
            "Encontros de financiamento colaborativo ou qualquer outra modalidade de arrecadação, cuja estratégia principal seja angariar fundos para fins políticos e eleitorais.",
    },
    {
        tipo: "item",
        id: "4.1.5.",
        texto:
            "Encontros cujo conteúdo aborde assuntos sensíveis, cujas repercussões ainda sejam desconhecidas ou cujas pautas exijam cautela na sua divulgação ou exploração, especialmente em casos em que esses parâmetros de cautela ainda não estejam bem definidos pelas autoridades competentes, pela legislação, pelos tribunais ou por critérios sociais relevantes.",
    },
    {
        tipo: "item",
        id: "4.1.6.",
        texto:
            "Encontros com conteúdo contrário a regras ou diretrizes emitidas por autoridades de saúde pública nacionais ou internacionais, cuja veiculação possa colocar em risco a saúde dos Usuários da Plataforma ou da coletividade.",
    },
    {
        tipo: "item",
        id: "4.1.7.",
        texto:
            "Encontros na área da saúde voltados ao público leigo que, em detrimento das regras ou diretrizes de saúde, recomendem terapias ou tratamentos alternativos com promessa de eficácia contra patologias ou seus sintomas, capazes de colocar em risco a saúde de quem os aplicar.",
    },
    {
        tipo: "item",
        id: "4.1.8.",
        texto:
            "Encontros que façam apologia a qualquer hábito que possa trazer consequência danosa para a saúde da coletividade.",
    },
    {
        tipo: "item",
        id: "4.1.9.",
        texto:
            "Encontros cujo conteúdo tenha material pornográfico, em especial contendo cenas explícitas, com conotação obscena, de nudez ou de atos sexuais.",
    },
    {
        tipo: "item",
        id: "4.1.10.",
        texto:
            "Encontro cuja divulgação invoque sua observância a diretrizes de sustentabilidade sem haver evidências plausíveis a respeito.",
    },
    {
        tipo: "secao",
        texto:
            "5. INFORMAÇÕES FALSAS",
    },
    {
        tipo: "item",
        id: "5.1.",
        texto:
            "Em caso de falsidade profissional de quem se declara ser, por exemplo, advogado, psicólogo e não seja, terá o prazo de 24h para corrigir tal informação, sob pena se banimento da plataforma.",
    },
    {
        tipo: "item",
        id: "5.2.",
        texto:
            "As informações falsas denunciadas e verificadas dentro dos Encontros, após análise da Empiria, poderá ensejar suspensão ou banimento da Plataforma.",
    },
];

export default usoResponsavel;
